import * as Sentry from "@sentry/browser";

// Initialize Sentry
Sentry.init({
  dsn: "https://824c001b6b636e7385ce05bd6d6359df@o4508937207742464.ingest.de.sentry.io/4508937249947728",
  release: "tshmanager@1.0.0",
  integrations: [
    Sentry.browserTracingIntegration({
      // Alapértelmezett browser tracing
      traceIncomingRequests: true,
      traceXHR: true,
      traceFetch: true,
    }),
    Sentry.replayIntegration({
      // Csak hibák esetén replay
      sessionSampleRate: 0,
      errorSampleRate: 0.1, // 10% replay hibák esetén
    }),
  ],
  // Intelligens sampling rate
  tracesSampleRate: 0.05, // 5% sampling frontend-en
  tracePropagationTargets: ["localhost", /^https:\/\/app\.tshmanager\.hu/],
  
  // Teljesítmény optimalizációk
  maxBreadcrumbs: 15, // Csökkentett breadcrumb szám
  beforeSend(event) {
    // Kiszűrjük a statikus fájlok hibáit
    if (event.request?.url?.match(/\.(css|js|png|jpg|jpeg|gif|ico|svg|woff|woff2|ttf|eot)$/)) {
      return null;
    }
    return event;
  },
});

// Export Sentry instance for use in identify script
window.Sentry = Sentry;

